/*
 * @Author: Fu Zhuohang
 * @Date: 2022-01-04 18:06:33
 * @LastEditors: Fu Zhuohang
 * @LastEditTime: 2022-02-21 15:49:22
 * @FilePath: \yunshu6.0\modules\@cloudpivot\application\src\components\pc\locales\zh-CN.ts
 * @Description:
 */
export default {
    inputAppName: '请输入应用名称',
    noResult: '暂无“{keyword}”相关的搜索结果',
    cancelCollection: '取消收藏',
    addToCollection: '加入收藏',
    moreData: '查看更多',
    owningApplication: '所属应用',
    allApplications: '全部应用',
    searchBox: {
        inputSearch: '请输入搜索内容',
        search: '搜 索',
        all: '全部',
        application: '应用',
        model: '模型',
        workflow: '流程',
        notification: '消息通知',
        toDoTask: '【流程】我的待办',
        total: '共',
        results: '个结果',
        more: '更多',
        owningApplication: '所属应用：',
        noSearchResult: '暂无搜索结果',
        searching: '努力搜索中',
        Notifications: '站内消息',
        AltAndReply: '@和回复我的',
    },
    notificationItem: {
        you1: '您',
        checkDetail: '查看详情',
    }
};
